import React from 'react';

import TestCaseExecutionStatus from './TestCaseExecutionStatus';
import { TestCaseExecutionStatusPageContextProvider } from './TestCaseExecutionStatusPageProvider';

export default function TestCaseExecutionStatusPage(): JSX.Element {
  return (
    <TestCaseExecutionStatusPageContextProvider>
      <TestCaseExecutionStatus />
    </TestCaseExecutionStatusPageContextProvider>
  );
}
